
export enum UserProvisioningType {
    Undefined = 0,
    Aad = 1,
    Okta = 2
}
